import type { Meal, Settings } from '../shared/types.ts';

export const LB = 2.20462;

export function today(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function shiftDate(date: string, n: number): string {
  const d = new Date(date + 'T12:00:00Z');
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

export function prettyDate(date: string, long = true): string {
  const t = today();
  if (date === t) return 'Today';
  if (date === shiftDate(t, -1)) return 'Yesterday';
  if (date === shiftDate(t, 1)) return 'Tomorrow';
  return new Date(date + 'T12:00:00Z').toLocaleDateString(undefined, {
    timeZone: 'UTC', weekday: long ? 'short' : undefined, month: 'short', day: 'numeric',
  });
}

export const kcal = (n: number) => Math.round(n).toLocaleString();
export const grams = (n: number) => `${Math.round(n)} g`;

export function weight(kg: number | null | undefined, s: Settings, digits = 1): string {
  if (kg === null || kg === undefined) return '—';
  return s.units === 'imperial' ? `${(kg * LB).toFixed(digits)} lb` : `${kg.toFixed(digits)} kg`;
}

export const weightUnit = (s: Settings) => (s.units === 'imperial' ? 'lb' : 'kg');
export const toKg = (v: number, s: Settings) => (s.units === 'imperial' ? v / LB : v);
export const fromKg = (kg: number, s: Settings) => (s.units === 'imperial' ? kg * LB : kg);

export function duration(s: number): string {
  const h = Math.floor(s / 3600);
  const m = Math.round((s % 3600) / 60);
  return h ? `${h}h ${String(m).padStart(2, '0')}m` : `${m} min`;
}

/** The meal a log most likely belongs to at this time of day. */
export function mealNow(): Meal {
  const h = new Date().getHours();
  if (h < 10.5) return 'breakfast';
  if (h < 15) return 'lunch';
  if (h >= 17 && h < 22) return 'dinner';
  return 'snack';
}

export const MEAL_LABEL: Record<Meal, string> = {
  breakfast: 'Breakfast', lunch: 'Lunch', dinner: 'Dinner', snack: 'Snacks',
};

export function localTime(): string {
  return new Date().toLocaleString(undefined, { weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false });
}
